module.exports = __webpack_public_path__ + "img/friend-group-people-team-members.f2f0fffa.svg";